import { beginTask, endTask } from 'redux-nprogress';
import { selectQuery } from '../../../../store/reducers/location.selectors';
import { selectCurrent } from '../../../../store/reducers/season';
import { selectFormulasState } from '../../../../store/reducers/formula';
import {
  selectPositionsState,
  selectPositionsStatsMap,
  getPositionsStatsMap,
} from '../../../../store/reducers/positions';
import routes from '../../../routes.global';
import viewNames from '../../../../store/actions/view.types';
import { loadToolDescriptions } from '../../../../store/reducers/toolDescriptions';

// ------------------------------------
// Selectors
// ------------------------------------
export const STORE_KEY = 'seasonStats';
export const selectSeasonStatsState = state => state[STORE_KEY];

// ------------------------------------
// Reducer
// ------------------------------------
const actions = {};
const initialState = {
  stats: [],
  year: null,
  position: '',
  seasonType: 'REGULAR SEASON',
  formulaId: 1,
  hasLoaded: false,
  error: null,
};

const seasonStatsReducer = (state = initialState, action) => {
  const handler = actions[action.type];

  return handler ? handler(state, action) : state;
};

export default seasonStatsReducer;

// ------------------------------------
// Actions
// ------------------------------------
export const LOAD_SEASON_STATS_REQUEST = `${STORE_KEY}/LOAD_SEASON_STATS_REQUEST`;
export const LOAD_SEASON_STATS_SUCCESS = `${STORE_KEY}/LOAD_SEASON_STATS_SUCCESS`;
export const LOAD_SEASON_STATS_ERROR = `${STORE_KEY}/LOAD_SEASON_STATS_ERROR`;

export const loadSeasonStatsRequest = (year, formulaId, position, seasonType) => ({
  type: LOAD_SEASON_STATS_REQUEST,
  payload: { year, formulaId, position, seasonType },
});
export const loadSeasonStatsSuccess = (stats) => ({
  type: LOAD_SEASON_STATS_SUCCESS,
  payload: { stats },
});
export const loadSeasonStatsError = error => ({
  type: LOAD_SEASON_STATS_ERROR,
  payload: { error },
});

actions[LOAD_SEASON_STATS_REQUEST] = (
  state,
  { payload: { year, formulaId, position, seasonType } },
) => ({ ...state,
  year,
  formulaId,
  position,
  seasonType,
});
actions[LOAD_SEASON_STATS_SUCCESS] = (state, { payload: { stats } }) => ({ ...state,
  stats,
  hasLoaded: true,
});
actions[LOAD_SEASON_STATS_ERROR] = (state, { payload }) => ({ ...state,
  error: payload.error,
});

export const loadSeasonStats = (
  year,
  formulaId,
  position,
  seasonType,
) => async (dispatch, getState, { api }) => {
  try {
    dispatch(beginTask());
    dispatch(loadSeasonStatsRequest(year, formulaId, position, seasonType));
    const response = await api.stats.getSeasonForPosition(seasonType, year, position, formulaId);

    dispatch(loadSeasonStatsSuccess(response.season_position_stats));
  } catch (error) {
    console.error(error);
    dispatch(loadSeasonStatsError(error));
  } finally {
    dispatch(endTask());
  }
};

// ------------------------------------
// View / Route
// ------------------------------------
export const SEASON_STATS_VIEW = `${STORE_KEY}/SEASON_STATS_VIEW`;
export const SEASON_POSITION_STATS_MAP_KEY = 'player-stats-season';
viewNames[SEASON_STATS_VIEW] = 'Season';
routes[SEASON_STATS_VIEW] = {
  path: '/season',
  thunk: async (dispatch, getState) => {
    const state = getState();
    let { year, formulaId, seasonType, position } = selectQuery(state);

    if (!formulaId) formulaId = selectFormulasState(state).defaultFormula;
    if (year === null || year === undefined || year === 'null') year = selectCurrent(state, 'stats').season;
    if (!seasonType) seasonType = 'REGULAR SEASON';
    if (!position) position = selectPositionsState(state).stats[0];
    let positionsStatsMap = selectPositionsStatsMap(state, SEASON_POSITION_STATS_MAP_KEY);
    if (!positionsStatsMap) {
      await dispatch(getPositionsStatsMap(SEASON_POSITION_STATS_MAP_KEY));
      positionsStatsMap = selectPositionsStatsMap(getState(), SEASON_POSITION_STATS_MAP_KEY);
    }

    // Needs to await otherwise data won't load on SSR
    await dispatch(loadSeasonStats(year, formulaId, position, seasonType));
    await dispatch(loadToolDescriptions());
  },
};



// WEBPACK FOOTER //
// ./src/app/views/Season/module/seasonStats.js